import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './InternshipsStipendPage.css';
import axiosBaseURL from './httpCommon';


import profile_img from './images/profile_image.png';
import home_icon from './images/home-icon.png'
import whatsapp_icon from './images/whatsapp_icon.png'

const InternshipsStipendPage = () => {
    const [isProfileDropdownOpen, setProfileDropdownOpen] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const navigate = useNavigate();

    const handleProfileClick = () => {
        setProfileDropdownOpen(!isProfileDropdownOpen);
    };

    const handleLogout = () => {
        axiosBaseURL.get('/logout')
            .then(response => {
                navigate('/');
            })
            .catch(error => {
                console.error('Error during logout:', error);
                navigate('/');
            });
    };

    useEffect(() => {
        const iframeLoadHandler = () => {
            setLoading(false);
        };

        const iframe = document.getElementById('airtable-iframe');
        iframe.addEventListener('load', iframeLoadHandler);

        return () => {
            iframe.removeEventListener('load', iframeLoadHandler);
        };
    }, []);

    return (
        <div className="internships-stipend-page">
            <header className="page-header">
                <div className="left-content">
                    <img src={home_icon}
                         alt="Home"
                         className="home-icon" 
                         onClick={() => navigate('/home') } />
                </div>
                <div className="right-content">
                    <div className="profile-dropdown">
                        <img
                            src={profile_img}
                            alt="Profile"
                            className="profile-icon"
                            onClick={handleProfileClick}
                        />
                        {isProfileDropdownOpen && (
                            <div className="dropdown-menu">
                                <ul>
                                    <li onClick={() => window.open("https://boltiot.kampsite.co/", "_blank")} rel="noopener noreferrer">FEATURE REQUEST</li>
                                    <li onClick={handleLogout}>Logout</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {isLoading && (
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                </div>
            )}

            <iframe
                id="airtable-iframe"
                title="Internships Stipend Page"
                src="https://airtable.com/embed/shrL0fsU1jStfdc9Z?backgroundColor=blue"
                width="100%"
                height="100%"
                allowFullScreen
            ></iframe>

            <footer className="footer">
                <div className="footer-left">© Bolt IoT 2023</div>
                <div className="footer-center">
                    <a href="https://www.boltiot.com/termsofservice" target="_blank" rel="noopener noreferrer">Terms of Use</a>
                    <a href="https://www.boltiot.com/privacypolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </div>
                <div className="footer-right"></div>
            </footer>
        </div>
    );
};

export default InternshipsStipendPage;
